module.exports = __webpack_public_path__ + "static/media/32.5155df65.jpg";